<template>
  <div class="user">
    <div class="user-filter">
      <el-row>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-input class="user-filter-value" @keyup.enter.native="handleFilter" v-model.trim="search" placeholder="员工号 / Full Name" clearable size="small" suffix-icon="el-icon-search"></el-input>
          </div>
        </el-col>
        <el-col :span="8">
          <div>
            <el-button class="user-filter-reset" size="small" @click="searchReset">清除条件</el-button>
            <el-button class="user-filter-search" size="small" @click="handleFilter">立即筛选</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <basic-container>
      <avue-crud :option="option"
                 ref="crud"
                 v-model="form"
                 :page="page"
                 @on-load="getList"
                 :table-loading="listLoading"
                 @row-update="update"
                 @row-save="create"
                 @current-change="currentChange"
                 @size-change="sizeChange"
                 :before-open="handleOpenBefore"
                 :data="list">

        <template slot="menuLeft">
          <el-button type="primary" @click="handleCreate" icon="el-icon-plus" size="small" v-if="sys_user_add">新增</el-button>
        </template>

        <template slot="username"
                  slot-scope="scope">
          <span>{{scope.row.username}}</span>
        </template>
        <template slot="nickname"
                  slot-scope="scope">
          <span>{{scope.row.nickname}}</span>
        </template>
        <template slot="role"
                  slot-scope="scope">
              <span v-for="(role,index) in scope.row.roleList"
                    :key="index">
                <el-tag>{{role.roleName}} </el-tag>&nbsp;&nbsp;
              </span>
        </template>
        <template slot="deptId"
                  slot-scope="scope">
          {{scope.row.deptName}}
        </template>
        <template slot="lockFlag"
                  slot-scope="scope">
          <el-tag>{{scope.label}}</el-tag>
        </template>
        <template slot="member"
                  slot-scope="scope">
              <a href="javascript:void(0);" v-for="(member,index) in scope.row.memberList" :key="index"
                @click="goToUserDetail(member)"
                class="user-list-container-button">
                {{member.nickname}}</a>
        </template>
        <template slot="menu"
                  slot-scope="scope">
          <el-button v-if="sys_user_edit"
                     size="small"
                     type="text"
                     icon="el-icon-edit"
                     @click="handleUpdate(scope.row,scope.index)">编辑
          </el-button>
          <el-button v-if="sys_user_del"
                     size="small"
                     type="text"
                     icon="el-icon-delete"
                     @click="deletes(scope.row,scope.index)">删除
          </el-button>
        </template>
        <template slot="passwordForm">
          <el-input v-model="form.password"
                            placeholder="请输入密码"
                            type="password"
                            auto-complete="new-password"></el-input>
        </template>
        <template slot="roleForm">
          <avue-crud-select v-model="role"
                            placeholder="请选择角色"
                            :dic="rolesOptions"
                            :props="roleProps"></avue-crud-select>
        </template>
        <template slot="memberForm">
          <avue-crud-select v-model="form.memberId"
                            placeholder="请选择官方号"
                            :dic="membersOptions"
                            :props="memberProps"></avue-crud-select>
        </template>
      </avue-crud>
    </basic-container>
  </div>

</template>

<script>
  import {addObj, delObj, fetchList, putObj} from "@/api/admin/user";
  import { fetchAllByType as fetchMember } from '@/api/admin/member'
  import {deptRoleList} from "@/api/admin/role";
  import {tableOption} from '@/const/crud/admin/user';
  import {mapGetters} from "vuex";
  import MemberTypeEnum from '@/common/enums/MemberTypeEnum'

  export default {
    name: "table_user",
    data() {
      return {
        option: tableOption,
        treeDeptData: [],
        checkedKeys: [],
        roleProps: {
          label: "roleName",
          value: 'roleId'
        },
        memberProps: {
          label: "nickname",
          value: 'memberId'
        },
        defaultProps: {
          label: "name",
          value: 'id',
        },
        page: {
          total: 0, // 总页数
          currentPage: 1, // 当前页数
          pageSize: 10, // 每页显示多少条,
          isAsc: false//是否倒序
        },
        list: [],
        listLoading: true,
        role: [],
        form: {},
        rolesOptions: [],
        membersOptions: [],
        search: '',
      };
    },
    computed: {
      ...mapGetters(["permissions"])
    },
    watch: {
      role() {
        this.form.role = this.role
      }
    },
    created() {
      this.sys_user_add = this.permissions["sys_user_add"];
      this.sys_user_edit = this.permissions["sys_user_edit"];
      this.sys_user_del = this.permissions["sys_user_del"];
      this.init();
    },
    methods: {
      getList(page) {
        // 管理员列表仅列出管理员用户,不列出会员的无效用户
        // 1-管理员用户 2-会员无效用户
        let params = {}
        params.userType = 1
        if (this.search.trim()) {
          params.search = this.search.trim()
        }
        this.listLoading = true;
        fetchList(Object.assign({
          current: page.currentPage,
          size: page.pageSize
        }, params)).then(response => {
          this.list = []
          for (var item of response.data.data.records) {
            if (item.memberList.length > 0) {
              item.memberId = item.memberList[0].memberId
            }
            this.list.push(item)
          }
          this.page.total = response.data.data.total
          this.listLoading = false;
        });
      },
      handleMember() {
        fetchMember(MemberTypeEnum.ENTERPRISE.code).then(response => {
          this.membersOptions = response.data.data;
        });
      },
      getRoleData() {
        deptRoleList().then(response => {
          this.rolesOptions = response.data.data;
        });
      },
      handleFilter(params) {
        this.page.currentPage = 1
        this.getList(this.page)
      },
      searchReset() {
        this.search = ''
        this.getList(this.page)
      },
      // 页面展示数据条数发生变化
      sizeChange(val) {
        this.page.pageSize = val
      },
      // 页码发生变化
      currentChange(val) {
        this.page.currentPage = val
      },
      handleCreate() {
        tableOption.column.find((item) => item.prop === 'password').rules[0].required = true;
        this.$refs.crud.rowAdd();
      },
      handleOpenBefore(show, type) {
        window.boxType = type;
        this.handleMember();
        this.getRoleData();
        if (['edit', 'views'].includes(type)) {
          // this.role = [];
          // for (var i = 0; i < this.form.roleList.length; i++) {
          //   this.role[i] = this.form.roleList[i].roleId;
          // }
          this.role = this.form.roleList[0].roleId;
          this.form.role = this.role;
        } else if (type === 'add') {
          // this.role = [];
          this.role = null;
        }
        show();
      },
      handleUpdate(row, index) {
        tableOption.column.find((item) => item.prop === 'password').rules[0].required = false;
        this.$refs.crud.rowEdit(row, index);
        this.form.password = undefined
      },
      create(row, done, loading) {
        this.form.userType = 1
        const params = {...this.form};
        params.role = [];
        params.role.push(this.form.role);
        addObj(params).then(() => {
          this.getList(this.page);
          done();
          this.$notify({
            title: "成功",
            message: "创建成功",
            type: "success",
            duration: 2000
          });
        }).catch(() => {
          loading();
        });
      },
      update(row, index, done, loading) {
        const params = {...this.form};
        params.role = [];
        params.role.push(this.form.role);
        putObj(params).then(() => {
          this.getList(this.page);
          done();
          this.$notify({
            title: "成功",
            message: "修改成功",
            type: "success",
            duration: 2000
          });
        }).catch(() => {
          loading();
        });
      },
      deletes(row, index) {
        this.$confirm(
          "此操作将永久删除该用户(用户名:" + row.username + "), 是否继续?",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        ).then(() => {
          delObj(row.userId)
            .then(() => {
              this.list.splice(index, 1);
              this.$notify({
                title: "成功",
                message: "删除成功",
                type: "success",
                duration: 2000
              });
            })
            .cache(() => {
              this.$notify({
                title: "失败",
                message: "删除失败",
                type: "error",
                duration: 2000
              });
            });
        });
      },
      goToUserDetail(member) {
        this.$router.push({
          path: "/upms/member/official/detail/" + member.memberId,
        })
      }
    }
  };
</script>
<style lang="scss">
  .user {
    height: 100%;

    &-filter {
      margin: 0 10px;
      /deep/ .el-input__inner {
        border: none;
        font-size: 14px;
      }
      .el-row {
        width: 95%;
      }
      &-value {
        width: calc(100% - 12px) !important;
      }
      &-reset {
        margin-left: 10px;
      }
      &-search {
        margin-left: 10px;
        border-color: #5383f3;
        color: #5383f3;
      }
    }

    &-list-container {
        padding-top: 0px;
        &-button {
          color: #409EFF;
          font-size: 14px;
          text-align: center;
          font-weight: 500;
        }
      }
    &__tree {
      padding-top: 3px;
      padding-right: 20px;
    }

    &__main {
      .el-card__body {
        padding-top: 0;
      }
    }
  }
</style>

